import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DateTime } from 'luxon';
import { Message } from 'primeng/api';
import { MessageService } from '@shared/services/message-service';
import { Shift } from 'projects/shared/src/lib/models/shift';
import { OutboundLoad } from 'projects/warehousing/src/app/models/outbound-load';
import { OutboundLoadService } from 'projects/warehousing/src/app/services/outbound-load.service';
import { ShiftContextService } from 'projects/warehousing/src/app/services/shift-context.service';
import { environment } from '@environment';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { OutboundLoadStatus } from 'projects/warehousing/src/app/models/outbound-load-status';

@Component({
  selector: 'app-cancel-load',
  templateUrl: './cancel-load.component.html',
  styleUrls: ['./cancel-load.component.scss']
})
export class CancelLoadComponent implements OnInit {

  static readonly validationMessage: Message = {
        severity: 'warn',
        summary: 'Could Not Cancel Load',
        detail: 'Please correct the listed errors.'
    };

    static readonly successMessage: Message = {
        severity: 'success',
        summary: 'Load Canceled',
        detail: 'Load canceled successfully.'
    };

    private _show: boolean = false;

    @Input('show') set show(val: boolean) {
        this._show = val;
        this.showChange.emit(val);
    }

    get show(): boolean {
        return this._show;
    }

    @Output() showChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() load: OutboundLoad;

    @Output() loadCanceled: EventEmitter<OutboundLoad> = new EventEmitter<OutboundLoad>();

    loading: boolean = false;

    saving: boolean = false;

    form: UntypedFormGroup = new UntypedFormGroup({
        canceledShift: new UntypedFormControl(null, Validators.required)
    });

    get canceledShift(): AbstractControl { return this.form.get('canceledShift'); }

    selectedDate: DateTime;
    selectedShift: Shift;

    subscriptions: Subscription[];

    constructor(
        private loadService: OutboundLoadService,
        private shiftContextService: ShiftContextService,
        private messageService: MessageService) { }

    ngOnInit() { }

    ngOnDestroy() { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.show && changes.show.currentValue) {
            this.shiftContextService.CurrentContext.pipe(take(1)).subscribe(context => {
                this.canceledShift.setValue(context.id);
            });
        }

        // if (changes.load) {
        //     if (changes.load.currentValue)
        //         this.sealNumber.setValue(changes.load.currentValue.sealNumber);
        //     else
        //         this.sealNumber.setValue('');
        // }
    }

    Close() {
        this.show = false;
    }

    DateSelected(date: DateTime) {
        this.selectedDate = date;
    }

    ShiftSelected(shift: Shift) {
        this.selectedShift = shift;
    }

    CancelLoad() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();

            this.messageService.add(CancelLoadComponent.validationMessage);
            return;
        }

        this.saving = true;


        this.loadService.markLoadCanceled(this.load.id, this.canceledShift.value).subscribe({
            next: updated => {
                this.load.canceledWorkedShiftId = this.canceledShift.value;
                this.load.outboundLoadStatusId = OutboundLoadStatus.Canceled;
                this.loadCanceled.emit(updated);
                this.messageService.add(CancelLoadComponent.successMessage);

                this.show = false;
                this.saving = false;
            },
            error: _err => {
                this.saving = false;
            }
        });
    }
}
